import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AdvertisementForm from "../../component/admin/formComponents/AdvertisementForm";

const optionalUrlSchema = Yup.string()
  .trim()
  .test(
    "optional-url",
    "Enter a valid URL (http:// or https://)",
    (value) => {
      if (!value) return true;
      try {
        const url = new URL(value);
        return url.protocol === "http:" || url.protocol === "https:";
      } catch {
        return false;
      }
    }
  );

export default function AddAdvertisement() {
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      link: "",
      image: "",
    },
    validationSchema: Yup.object().shape({
      link: optionalUrlSchema,
      image: Yup.mixed().required("Banner image is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      const data = new FormData();
      if (values.link?.trim()) {
        data.append("link", values.link.trim());
      } else {
        data.append("link", "");
      }
      data.append("image", values.image);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/createAdvertisement`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          toast.success(response.data.message);
          navigate("/admin/dashboard/advertisements");
        } else {
          toast.error(response.data.message);
        }
      } catch (e) {
        toast.error(e?.response?.data?.message || "Failed to create advertisement");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress sx={{ color: "#ef364e" }} />
      </Backdrop>
      <Box className="free_votes_page">
        <Box className="page_title">
          <Typography variant="h1" component="h1">
            Create Advertisement
          </Typography>
        </Box>
        <AdvertisementForm formik={formik} edited={false} />
      </Box>
    </>
  );
}
